export const batchUpdateLearningResourceSet = `
  updateLearningResourceSet(input: $learningResourceSetInput) {
  
    clientMutationId
    
    learningResourceSet {
      id
      order
    }
  
    errors {
      message
      path
    }
  
  }
`;
